export default "__VITE_ASSET__g8W5w68J__"